import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, isRef as _isRef, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex config" }

import {ref, computed, Component, watch} from 'vue';
import OperatorApplicationSideMenu from "~/operatorApplication/vue/layout/OperatorApplicationSideMenu.vue";
import OperatorApplicationSideMenuItem from "~/operatorApplication/vue/layout/OperatorApplicationSideMenuItem.vue";
import {__} from "~/ts/library/Translate";
import OperatorApplicationConfigCommon from "~/operatorApplication/vue/config/OperatorApplicationConfigCommon.vue";
import OperatorApplicationConfigChat from "~/operatorApplication/vue/config/OperatorApplicationConfigChat.vue";
import OperatorApplicationConfigShortcuts
    from "~/operatorApplication/vue/config/OperatorApplicationConfigShortcuts.vue";
import OperatorApplicationConfigNotifications
    from "~/operatorApplication/vue/config/OperatorApplicationConfigNotifications.vue";
import OperatorApplicationConfigBuddyList
    from "~/operatorApplication/vue/config/OperatorApplicationConfigBuddyList.vue";
import OperatorApplicationPlatformFactory from "~/operatorApplication/ts/platform/OperatorApplicationPlatformFactory";
import OperatorApplicationUpdate from "~/operatorApplication/vue/config/OperatorApplicationUpdate.vue";
import AbstractOperatorApplicationDesktopPlatform
    from "~/operatorApplication/ts/platform/AbstractOperatorApplicationDesktopPlatform";
import OperatorApplicationConfigDownload from "~/operatorApplication/vue/config/OperatorApplicationConfigDownload.vue";
import OperatorApplicationServerSideConfig
    from "~/operatorApplication/vue/config/OperatorApplicationServerSideConfig.vue";
import {OperatorApplicationConfigInstance} from "~/operatorApplication/ts/service/OperatorApplicationConfig";
import Dictionary from "~/ts/library/Dictionary";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";


interface ConfigSection {
    id: string,
    descr: string,
    component: () => Component,
    props?: Dictionary<any>
}

const __default__ = {
    name: "OperatorApplicationConfig"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

let selected = ref<ConfigSection>();

let menu = computed(() => {
    let result: ConfigSection[] = [
        {id: "common", descr: __('Общие настройки'), component: () => OperatorApplicationConfigCommon},
        {id: "serverSide", descr: __("Настройки аккаунта"), component: () => OperatorApplicationServerSideConfig},
        {id: "notify", descr: __('Уведомления'), component: () => OperatorApplicationConfigNotifications},
        {
            id: "buddyList",
            descr: __('Список контактов'),
            component: () => OperatorApplicationConfigBuddyList,
            props: {
                configuration: OperatorApplicationConfigInstance,
                isServerSide: OperatorAccountStore.isServerSideSettings
            }
        },
        {id: "chat", descr: __('Чат'), component: () => OperatorApplicationConfigChat},
        {id: "shortcuts", descr: __('Горячие клавиши'), component: () => OperatorApplicationConfigShortcuts},
        // {id: "files", descr: __('Файлы'), component: OperatorApplicationConfigCommon},
        //{id: "clientInfo", descr: __('Информация о посетителе'), component: OperatorApplicationConfigCommon}
    ];
    if (OperatorApplicationPlatformFactory instanceof AbstractOperatorApplicationDesktopPlatform) {
        result.push({id: "update", descr: __('Обновление'), component: () => OperatorApplicationUpdate});
    }
    if (OperatorApplicationPlatformFactory.isPlatformCanDownload()) {
        result.push({
            id: "download",
            descr: __("Загрузка файлов"),
            component: () => OperatorApplicationConfigDownload
        })
    }
    return result;
});

function resetMenu() {
    selected.value = menu.value[0];

}

resetMenu();
watch(menu, resetMenu);



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(OperatorApplicationSideMenu, { padding: "" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menu), (item) => {
          return (_openBlock(), _createBlock(OperatorApplicationSideMenuItem, {
            key: item.id,
            onClick: ($event: any) => (_isRef(selected) //@ts-ignore
 ? selected.value = item : selected = item),
            selected: _unref(selected).id === item.id,
            class: "text-nowrap"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item.descr), 1)
            ]),
            _: 2
          }, 1032, ["onClick", "selected"]))
        }), 128))
      ]),
      _: 1
    }),
    (_unref(selected))
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(selected).component()), _mergeProps({ key: 0 }, _unref(selected).props, { class: "p-4 overflow-auto flex-fill" }), null, 16))
      : _createCommentVNode("", true)
  ]))
}
}

})